import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Slide,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * DuplicateSuccessModal
 * Shows confirmation that a form has been duplicated.
 * @param {boolean} open - Modal visibility state
 * @param {function} onClose - Handler to close the modal
 * @param {function} onNavigate - Handler to navigate to duplicated form
 */
const DuplicateSuccessModal = ({ open, onClose, onNavigate }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="duplicate-success-description"
      fullWidth
      maxWidth="sm"
      PaperProps={{
        elevation: 3,
        sx: {
          borderRadius: 3,
        }
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 3,
          textAlign: 'center',
          fontWeight: 600,
          fontSize: '1.25rem',
          position: 'relative'
        }}
      >
        Form Duplicated
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ px: 3, py: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography id="duplicate-success-description" variant="body1">
            A copy of this form has been created but not saved yet.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Click the button below to go to the duplicated form. Make any changes and click <strong>Save</strong> to access it later.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button variant="contained" onClick={onNavigate} autoFocus>
          Go to Duplicated Form
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateSuccessModal;
